import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SearchableDropdowns from './components/SearchableDropdowns';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {process.env.REACT_APP_LOCAL_WORKSPACE === 'true' && <div style={{ background:'#fff3cd',color:'#664d03',padding:'10px 16px',textAlign:'center',fontWeight:700 }} role="status">LOCAL WORKSPACE — Data is saved on this computer. Not published to GoDaddy.</div>}
    <App />
    <SearchableDropdowns />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
